import { DateStandardSettings } from 'apps/studio/components/settings/fields/Date/standard'
import { FieldSettingsPanel } from 'apps/studio/components/settings/fields/Base/standard'
import { DesignSettingsPanel } from 'apps/studio/components/settings/fields/Base/design'
import { AdvancedPanel } from 'apps/studio/components/settings/fields/Base/advanced'

export const DateSettings = [
  FieldSettingsPanel(DateStandardSettings),
  DesignSettingsPanel,
  // ConditionsPanel,
  AdvancedPanel,
]
